// @ts-nocheck
import { useEffect, useRef, useState } from 'react';

export function useNearViewport({ rootMargin = '200px', once = true, initialVisible = false } = {}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(initialVisible);

  useEffect(() => {
    if (isVisible && once) return undefined;
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        setIsVisible(true);
        if (once) observer.disconnect();
      },
      { rootMargin }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [isVisible, once, rootMargin]);

  return [ref, isVisible];
}
